// 14 real clients provided by dotMKV Media. Showreel maps each real reaction
// video to the client who reacted to it.

export const SHOWREEL = [
  { id: "LCUWIRoNAcs", title: "Harry Potter · Reaction Edit", client: "@Eralia" },
  { id: "J5M39BF6U4w", title: "Scary Movie · Reaction Edit", client: "@Jess & Tess React" },
  { id: "aVad3VupGOA", title: "Interstellar · Reaction Edit", client: "@Kaliwali" },
  { id: "f_V3N4WJCJY", title: "The Equalizer · Reaction Edit", client: "@ScreenJam" },
  { id: "6G_doVK9HPE", title: "The Amazing Spider-Man · Reaction Edit", client: "@Kaliwali" },
  { id: "-G3dOwMFAJc", title: "The Martian · Reaction Edit", client: "@Jrocks & Devinity" },
  { id: "kKIcjQ39NmU", title: "Avengers · Reaction Edit", client: "@Eralia" },
  { id: "RAiSq_xB1tc", title: "Matrix Revolutions · Reaction Edit", client: "@Natascha Summers" },
];

export const GAMING = [
  { id: "4GoMD9inLzY", title: "007 First Light", client: "" },
  { id: "dYTxwhWsCbo", title: "Astro Bot", client: "" },
  { id: "Dym0W6zGq18", title: "Clair Obscur: Expedition 33", client: "" },
  { id: "I-rsvK6PgHc", title: "Resident Evil: Requiem", client: "" },
  { id: "23JropejeY4", title: "Uncharted 4", client: "" },
  { id: "Kk3ivEPuwnQ", title: "Spider-Man 2", client: "" },
  { id: "pWl7rFsWaHo", title: "God of War: Valhalla", client: "" },
  { id: "WF2WhVauGtM", title: "God of War — State of Play", client: "" },
];

export const CLIENTS = [
  { handle: "@Eralia", url: "https://www.youtube.com/@eralia", tag: "Reaction Channel" },
  { handle: "@Jrocks & Devinity", url: "https://www.youtube.com/@JrocksAndDevinity", tag: "Reaction Channel" },
  { handle: "@Jess & Tess React", url: "https://www.youtube.com/@JessAndTess", tag: "Reaction Channel" },
  { handle: "@Kaliwali", url: "https://www.youtube.com/@kaliwali", tag: "Reaction Channel" },
  { handle: "@ScreenJam", url: "https://www.youtube.com/@ScreenJamm", tag: "Reaction Channel" },
  { handle: "@Artizan_tv", url: "https://www.youtube.com/results?search_query=Artizan_tv", tag: "Reaction Channel" },
  { handle: "@The Otaku's Journey", url: "https://www.youtube.com/@theotakusjourney", tag: "Reaction Channel" },
  { handle: "@NellyWatches", url: "https://www.youtube.com/results?search_query=NellyWatches", tag: "Reaction Channel" },
  { handle: "@Off-Script-Therapy", url: "https://www.youtube.com/results?search_query=Off+Script+Therapy", tag: "Reaction Channel" },
  { handle: "@MrFlicks", url: "https://www.youtube.com/results?search_query=MrFlicks", tag: "Reaction Channel" },
  { handle: "@Totally Whatever", url: "https://www.youtube.com/results?search_query=Totally+Whatever", tag: "Reaction Channel" },
  { handle: "@Cynthetic", url: "https://www.youtube.com/results?search_query=Cynthetic", tag: "Reaction Channel" },
  { handle: "@Thats What She Said", url: "https://www.youtube.com/results?search_query=Thats+What+She+Said", tag: "Reaction Channel" },
  { handle: "@Natascha Summers", url: "https://www.youtube.com/results?search_query=Natascha+Summers", tag: "Reaction Channel" },
];

export const TESTIMONIALS = [
  {
    quote:
      "I think you guys are doing great. I tried many editors before and never was satisfied with their work and wouldn't ever go back to them. I've done several videos with you and will do many more.",
    author: "@Jess & Tess React",
    role: "Reaction Channel",
  },
  {
    quote:
      "Absolutely LOVE this editing company and you all have made my channel quality so much better since we've been working together. I can't thank you enough for that.",
    author: "@Kaliwali",
    role: "Reaction Channel",
  },
  {
    quote:
      "I really appreciate our working relationship. You are very easy to work with, fantastic communication, very responsive, honest and open, and quick to take care of any requests or copyright claims. Your team's turn around time is also fantastic.",
    author: "@Jrocks & Devinity",
    role: "Reaction Channel",
  },
];

export const SERVICES = [
  { n: "01", title: "Reaction Video Editing", body: "Movies, TV shows, season finales — clean overlays, copyright-safe cuts, platform-ready exports." },
  { n: "02", title: "Podcast Editing", body: "Multi-cam podcasts polished into long-form episodes and short-form clips that travel." },
  { n: "03", title: "Shorts & Reels", body: "Vertical edits, snappy captions, retention-tuned hooks for YouTube Shorts, TikTok, and Reels." },
  { n: "04", title: "Thumbnails & Design", body: "Click-worthy thumbnails and channel graphics designed for the reaction-content algorithm." },
];

export const STATS = [
  { value: "100+", label: "Creators Edited For" },
  { value: "3.2K", label: "Videos Edited" },
  { value: "52.5M+", label: "Views Generated" },
  { value: "<48H", label: "Avg. Turnaround" },
];

export const THUMBNAILS = [
  { src: "/img/thumbs/avengers.jpg", title: "Avengers: Infinity War" },
  { src: "/img/thumbs/spiderverse.jpg", title: "Spider-Man: Across the Spider-Verse" },
  { src: "/img/thumbs/vox-machina.jpg", title: "The Legend of Vox Machina · 4x1" },
  { src: "/img/thumbs/hail-mary.jpg", title: "Project Hail Mary" },
  { src: "/img/thumbs/martian.jpg", title: "The Martian" },
];

export const FAQS = [
  {
    q: "Who is this for?",
    a: "YouTube creators, podcasters, and online brands where content quality directly impacts growth. We work with English-speaking channels — primarily in the US, UK, and Canada — who are serious about publishing consistently and want a production team they don't have to manage. We're selective about who we take on. If you're looking for a one-off edit, we're probably not the right fit.",
  },
  {
    q: "What's the minimum commitment? Can I start with a trial?",
    a: "We don't do trial months. Getting your editing style right, building the workflow, and delivering at a consistent standard takes time from both sides — one video isn't enough to do that properly. Most clients come in on a per-video basis and naturally move into a regular cadence because the process works. The longer we work together, the sharper the output gets.",
  },
  {
    q: "How does the editing process actually work?",
    a: "You send us the raw footage, a brief or reference, and any specific notes. We edit, deliver a draft within the agreed turnaround window, collect your feedback, and revise. Every project includes two revision rounds. We use Frame.io for feedback — no back-and-forth over email or DMs. Simple, async, and trackable.",
  },
  {
    q: "Do you work across different content formats?",
    a: "Yes. Long-form YouTube videos, reaction content, podcast edits (audio and video), short-form clips for Instagram and TikTok, and TV series or episode edits. If it's video content meant for an online audience, we can handle it. We'll tell you upfront if something falls outside what we do well.",
  },
  {
    q: "Is there any guarantee on quality or results?",
    a: "We can guarantee the quality of the work — clean edits, on-brand delivery, on time, every time. We can't guarantee the algorithm. What we can tell you is that consistent, well-produced content is the only thing that feeds it reliably. If after two revisions a delivery genuinely misses the brief, we'll fix it. No arguments.",
  },
  {
    q: "What do you charge?",
    a: "Pricing is per project, not a monthly retainer. Long-form video edits start at a flat rate covering up to 120 minutes of raw footage, with a per-minute rate beyond that. Short-form clips are charged per video. Exact rates depend on the format and scope — reach out and we'll send you our current rate card.",
  },
  {
    q: "How do payments work?",
    a: "We invoice in USD. Payment is accepted via PayPal or Wise. Invoices are due within 15 days of delivery. For new clients, we typically ask for the first invoice to be settled before the next project begins — straightforward on both sides.",
  },
  {
    q: "Where is your team based?",
    a: "We're an India-based post-production agency working with international clients across the US, UK, and Canada. The time zone gap works in your favour — send us footage before you sleep, wake up to a draft. Communication is async by design, with scheduled check-ins when needed.",
  },
];

export const SOCIALS = {
  instagram: "https://www.instagram.com/dotmkvmedia",
  x: "https://x.com/dotmkvmedia",
  email: "team@dotmkvmedia.com",
  cal: "https://cal.com/dotmkv-media-sgkgdp/30min",
};
